<template>
  <div>
    <a-form-model ref="companyDetailsForm" :model="company" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="First Name" prop="contact.firstName">
            <a-input ref="firstName" placeholder="First Name" v-model="company.contact.firstName" autofocus/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Surname" prop="contact.lastName">
            <a-input placeholder="Surname" v-model="company.contact.lastName" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Company Name" prop="name">
            <a-input placeholder="Company Name" v-model="company.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Phone Number" prop="contact.phone">
            <a-input v-model="company.contact.phone" placeholder="Phone Number">
              <a-icon slot="prefix" type="phone" />
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Firm Size" prop="size">
            <a-select v-model="company.size" style="width: 100%">
              <a-select-option v-for="size in lookupState.firmSizes" :key="size.id" :value="size.id">
                {{ size.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Firm Type" prop="type">
            <a-select v-model="company.type" style="width: 100%">
              <a-select-option v-for="type in lookupState.firmTypes" :key="type.id" :value="type.id">
                {{ type.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Post Code" prop="address.postcode">
            <a-input placeholder="Postcode" v-model="company.address.postcode" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Country">
            <a-select v-model="company.address.countryId" style="width: 100%">
              <a-select-option v-for="country in lookupState.countries" :key="country.id" :value="country.id">
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="`Desired GLS subdomain (https://${company.subdomain?company.subdomain:''}.mygls.co.uk)`" prop="subdomain">
            <a-input placeholder="Subdomain" v-model="company.subdomain"  @blur="subdomainChanged=true" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>
<script>
import { helper } from '../../../Utilities/helper';
import { lookupState, lookupMutations } from '../../../Store/store.js';
export default {
  props: {
    company: {
      type: Object,
      required: true,
    },
    events: { type: Object, required: true },
    validate: Boolean,
  },
  mounted() {
    this.$refs.firstName.focus();
    this.lookupMutations.getCountries();
    this.lookupMutations.getFirmTypes();
    this.lookupMutations.getFirmSizes();
  },
  data() {
    return {
      subdomainChanged:false,
      desiredUrl:'',
      rules: {
        name: [{ required: true, message: 'Please input a company name', trigger: 'blur' }],
        'contact.firstName': [
          { required: true, message: 'Please input your first name', trigger: 'blur' },
          { validator: helper.nameValidator, trigger: 'blur' },
        ],
        'contact.lastName': [
          { required: true, message: 'Please input your surname', trigger: 'blur' },
          { validator: helper.nameValidator, trigger: 'blur' },
        ],
        'contact.phone': [
          { required: true, message: 'Please input your phone number', trigger: 'blur' },
          { validator: helper.phoneValidator, trigger: 'blur' },
        ],
        subdomain: [
          { required: true, message: 'Please input subdomain', trigger: 'blur' },
          { validator: helper.subdomainValidator, trigger: 'blur' },
        ],
        type: [{ required: true, message: 'Please select a firm type', trigger: 'blur' }],
        size: [{ required: true, message: 'Please select a firm size', trigger: 'blur' }],
      },
      lookupState: lookupState,
      lookupMutations: lookupMutations,
    };
  },
  watch: {
    validate(newVal) {
      if (newVal) {
        this.$refs.companyDetailsForm.validate((valid) => {
          if (valid) {
            this.$emit(this.events.moveNext, { source: 'CompanyDetails', isValid: true });
          }
        });
      }
    },
    'company.name':{
            handler: function (val) {
             if(!this.subdomainChanged)
                {
                  this.company.subdomain=val;
                }
            }
        },
    'company.subdomain':{
          handler: function (val) {
                this.company.subdomain=val.toLowerCase().trim().replace(/[^a-z0-9]+/g, "");
          }
      }

  },
};
</script>

<style lang="scss">
</style>
